import { render, staticRenderFns } from "./ListPackage.vue?vue&type=template&id=8c809746&scoped=true"
import script from "./ListPackage.vue?vue&type=script&lang=js"
export * from "./ListPackage.vue?vue&type=script&lang=js"
import style0 from "./ListPackage.vue?vue&type=style&index=0&id=8c809746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c809746",
  null
  
)

export default component.exports